import { FC } from 'react';
import { Typography } from '@mui/material';

interface MessageTextProps {
    text: string;
}

export const MessageText: FC<MessageTextProps> = ({ text }) => {
    if (!text) return null;

    return (
        <Typography variant="body2" sx={{ mb: 1.5, whiteSpace: 'pre-wrap' }}>
            {text}
        </Typography>
    );
};

